import { PropsWithChildren } from "react";
import { LayersControl, MapContainer, TileLayer } from "react-leaflet";

import { colors } from "@covertree/theme/colors";
import { layerDef } from "./utils";
import { styled } from "@mui/material/styles";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
  "& .leaflet-control-zoom": {
    borderRadius: 15,
    border: `2px solid ${colors.green3}`,
    "& a > span": {
      fontWeight: 200,
    },
    "& a:not(.leaflet-disabled) > span": {
      color: colors.green3,
    },
    "& .leaflet-control-zoom-in": {
      borderTopLeftRadius: "15px !important",
      borderTopRightRadius: "15px !important",
    },
    "& .leaflet-control-zoom-out": {
      borderBottomLeftRadius: "15px !important",
      borderBottomRightRadius: "15px !important",
    },
  },
  "& .leaflet-control-layers": {
    borderRadius: 15,
    border: `2px solid ${colors.green3}`,
  },
};

const StyledMapContainer = styled(MapContainer)(mapContainerStyle);

export function Map({ children }: PropsWithChildren) {
  return (
    <StyledMapContainer
      center={[39.5, -98.35]}
      zoom={4}
      minZoom={4}
      scrollWheelZoom>
      <LayersControl position="bottomleft">
        {layerDef.map((layer) => (
          <LayersControl.BaseLayer
            key={layer.name}
            name={layer.name}
            checked={layer.checked}>
            <TileLayer
              url={layer.url}
              attribution={layer.attribution}
              subdomains={layer.subdomains}
            />
          </LayersControl.BaseLayer>
        ))}
      </LayersControl>
      {children}
    </StyledMapContainer>
  );
}
